export default __webpack_public_path__ + "static/media/hamburger.a3bc6305.svg";